import { render } from "./SectionEditor.vue?vue&type=template&id=6846315c&scoped=true"
import script from "./SectionEditor.vue?vue&type=script&lang=js"
export * from "./SectionEditor.vue?vue&type=script&lang=js"

import "./SectionEditor.vue?vue&type=style&index=0&id=6846315c&scoped=true&lang=less"
import "./SectionEditor.vue?vue&type=style&index=1&id=6846315c&lang=less"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6846315c"]])

export default __exports__